import React from "react";
import {Attachment, Customer, SepaMandate, SepaMandateRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import FormFile from "../../../../components/form/form_inputs/form_file";
import {types} from "../../../../components/form/types";
import {Alert, Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {useSearchParams} from "react-router-dom";

export const SepaMandateEditPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(SepaMandateRestControllerApiFactory);
	const [searchParams] = useSearchParams();

	const customerIdValue = searchParams.get("customerId");

	const form = useForm({
		fetcher: (id) => ctrl.getSepaMandate(id),
		updater: (bean) => ctrl.saveSepaMandate(bean),
		remover: (id) => ctrl.deleteOrDismissSepaMandate(id),
		factory: () => {
			return {
				customer: (customerIdValue ? {id: Number(customerIdValue)} : {}) as Customer,
				attachment: {} as Attachment,
				scheme: "CORE",
				status: "ACTIVO",
			} as SepaMandate;
		},
		extraActions: [
			{
				label: "Revocar",
				action: () => {
					const id = form.getId();
					if (!id) {
						return;
					}
					const motivo = prompt(
						"El mandato se conserva revocado (no se borra: es la prueba de los cargos " +
						"que amparó).\n\n¿Motivo de la revocación?");
					if (motivo === null) {
						return;
					}
					apiManager
					.execute(ctrl.revokeSepaMandate(id, motivo))
					.then(() => form.load());
				},
			},
		],
	} as UseFormProps<SepaMandate>);

	return (
		<>
			<FormContent form={form} title={"Mandato SEPA"}>

				<Alert sx={{mb: 2}} color={"info"}>
					Un cliente solo puede tener un mandato ACTIVO. Al firmar uno nuevo, el anterior se
					revoca solo y se conserva: es lo que hay que poder enseñar si discute un cargo.
				</Alert>

				<Grid container spacing={3}>
					<Grid item xs={12} sm={5}>
						<FormAutocomplete field={"customer"} label={"Cliente"} type={types.customers}/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<FormInput field={"reference"} label={"Referencia"}
								   helperText={"Se genera sola si se deja vacía"}/>
					</Grid>
					<Grid item xs={12} sm={3}>
						<FormSelect field={"status"} label={"Estado"} type={types.sepaMandateStatuses}/>
					</Grid>
				</Grid>

				<Grid container spacing={3}>
					<Grid item xs={12} sm={5}>
						<FormInput field={"iban"} label={"IBAN"}
								   helperText={"Se valida el dígito de control al guardar"}/>
					</Grid>
					<Grid item xs={12} sm={3}>
						<FormInput field={"swift"} label={"BIC/SWIFT"}
								   helperText={"Opcional dentro de la zona SEPA"}/>
					</Grid>
					<Grid item xs={12} sm={4}>
						<FormInput field={"debtorName"} label={"Titular de la cuenta"}
								   helperText={"Si no coincide con el titular real, el banco devuelve el recibo"}/>
					</Grid>
				</Grid>

				<Grid container spacing={3}>
					<Grid item xs={12} sm={3}>
						<FormSelect field={"scheme"} label={"Esquema"} type={types.sepaSchemes}/>
					</Grid>
					<Grid item xs={12} sm={3}>
						<FormInput field={"signatureDate"} type={"date"} label={"Fecha de firma"}/>
					</Grid>
					<Grid item xs={12} sm={3}>
						<FormInput field={"lastUsedDate"} type={"date"} label={"Último cargo"}
								   helperText={"CORE caduca a los 36 meses sin uso"}/>
					</Grid>
					<Grid item xs={12} sm={3}>
						<FormInput field={"revokedDate"} type={"date"} label={"Revocado el"}/>
					</Grid>
				</Grid>

				<FormInput field={"signatureEvidence"} label={"Dónde está la prueba de la firma"} rows={2}
						   helperText={"Ruta de Dropbox o correo en el que llegó firmado, si no se sube aquí"}/>

				<FormFile
					field={"attachment"}
					label={"Documento firmado"}
					onDownload={() => apiManager.executeRaw(ctrl.downloadSepaMandate(form.getIdOrErr()))}
				/>

				<FormInput field={"notes"} label={"Observaciones"} rows={4}/>

			</FormContent>
		</>
	);
};
